import React from "react";
import { Link } from "react-router-dom";

/**
 * Terms — static Terms of Service surface. Content is deliberately
 * concise + creator-focused (this is a live-streaming platform), and
 * echoes the actual product behaviour so viewers/creators know what
 * they're agreeing to. Update the effective date + email below when
 * the substance changes.
 */
export default function Terms() {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-[#050810] text-white pt-24 pb-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-tv-accent text-[10px] uppercase tracking-[0.3em] font-black mb-2">Legal</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tighter mb-2">Terms of Service</h1>
        <div className="text-white/40 text-xs mb-8">Effective February 2026 · Tap In TV Network</div>

        <div className="prose prose-invert prose-sm max-w-none text-white/80 space-y-5">
          <section>
            <h2 className="font-display font-black text-white text-lg mt-2">1. Who we are</h2>
            <p>Tap In TV Network (&ldquo;Tap In&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) is a live broadcasting, video, and creator platform. By using our website, mobile web, or apps you agree to these terms.</p>
          </section>
          <section>
            <h2 className="font-display font-black text-white text-lg">2. Your account</h2>
            <p>You must be at least 13 years old to hold an account, and 18+ to access age-restricted content. You are responsible for your account credentials and all activity under them.</p>
          </section>
          <section>
            <h2 className="font-display font-black text-white text-lg">3. Content &amp; creators</h2>
            <p>Creators keep ownership of the content they upload; by uploading you grant Tap In a worldwide, non-exclusive license to host, transcode, thumbnail, and stream that content for the purpose of running the platform.</p>
            <p>You must have the rights to everything you upload — including audio, music, footage, and likeness. Repeated infringement leads to account termination and payout freeze.</p>
          </section>
          <section>
            <h2 className="font-display font-black text-white text-lg">4. Prohibited conduct</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>No CSAM, no non-consensual sexual content, no doxxing, no illegal activity.</li>
              <li>No harassment, targeted hate, or threats.</li>
              <li>No illegal drugs, no weapon sales, no fraud.</li>
              <li>No scraping or reverse-engineering the platform.</li>
            </ul>
          </section>
          <section>
            <h2 className="font-display font-black text-white text-lg">5. Payments &amp; payouts</h2>
            <p>Purchases (tips, PPV, subscriptions, gifts) are processed via Stripe. Creator payouts follow the schedule + revenue split disclosed in the Creator Dashboard. Refunds are handled per the payment provider&apos;s policy; chargebacks may result in a payout hold.</p>
          </section>
          <section>
            <h2 className="font-display font-black text-white text-lg">6. Termination</h2>
            <p>We can suspend or terminate accounts that violate these terms, applicable law, or the DMCA. You can delete your account at any time via Settings; deletion is irreversible.</p>
          </section>
          <section>
            <h2 className="font-display font-black text-white text-lg">7. Warranty &amp; liability</h2>
            <p>Tap In is provided &ldquo;as is&rdquo; without warranty. To the extent permitted by law we are not liable for consequential, indirect, or incidental damages.</p>
          </section>
          <section>
            <h2 className="font-display font-black text-white text-lg">8. Changes to these terms</h2>
            <p>We may update these terms. Material changes will be announced in-app; continued use after 30 days constitutes acceptance.</p>
          </section>
          <section>
            <h2 className="font-display font-black text-white text-lg">9. Contact</h2>
            <p>Questions? Email <a className="text-tv-accent hover:underline" href="mailto:legal@tapintvnetwork.com">legal@tapintvnetwork.com</a>. Read our <Link to="/privacy" className="text-tv-accent hover:underline">Privacy Policy</Link> for how we handle your data.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
